import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Rate, Button, Input, Form } from 'antd';
import axios from 'axios';
import { getActivityID, getConfig, getSid,getChatState } from '../redux/reducers/app';
import { surveySubmitted,setToken } from '../redux/actions/chatAction';

const { TextArea } = Input;

const Survey = (props) => {
    const { 
		agentassigned
	} = props;
    const dispatch = useDispatch();
    const sid = useSelector(state => getSid(state));
    const activityid = useSelector(state => getActivityID(state));
    const chatstate=useSelector(state => getChatState(state));
    const appConfig = useSelector(state => getConfig(state));
    const survey = appConfig.survey;
    const questions = survey.questions;

    const onFinish = async (values) => {
        const keys = Object.keys(values);
        let surveyBody = '';
        keys.forEach(key => {
            const qType = key.split('-')[0];
            const qIndex = Number(key.split('-')[1]);
            if(qType === 'rating') {
                surveyBody = surveyBody +  
                `<survey>
                    <question>${questions[qIndex].question}</question>
                    <answer>${values[key]}</answer>
                </survey>`
            }
            if(qType === 'comment') {
                surveyBody = surveyBody +   
                `<survey>
                    <question>surveyText</question>
                    <answer><![CDATA[${values[key]}]]></answer>
                </survey>`
            }
        });

        if(sid === '') {
            console.log('sid is empty');
            dispatch(surveySubmitted());
            // setTimeout(() => {
            //     // dispatch(chatInit());
            //     // reload page on succsful survey submission
            //     localStorage.clear();
            //     window.location.reload(false);
            // }, 3000);
            dispatch(setToken(''));
            return;
        }

        const body = 
        `<?xml version="1.0" encoding="UTF-8"?>
        <egainSurvey sid="${sid}"
        xmlns="${appConfig.surveyUrl}">
            ${surveyBody}
        </egainSurvey>`

        const config = {
            headers: {'Content-Type': 'text/xml'}
        };

        try {
            const laststate=localStorage.getItem('laststate');
            console.log('[survey] before submit sid: ', sid,' chatstate:',chatstate,' activityid:',activityid,' laststate:',laststate,' agentassigned:',agentassigned);
            const res = await axios.post(appConfig.entryPoint, body, config);
            dispatch(surveySubmitted());
            if(survey && survey.debug){
                var data =
                {
                    meta01: activityid,
                    code: '6000',
                    mapKey: chatstate,
                    meta02: laststate,
                    meta03: agentassigned
                }
            }
            try {
                if(survey.pushurl!=='') {
                    const res = await axios.post(survey.pushurl, data);
                    console.log('[survey][debug]res: ', res.data);
                } else {
                    // disposition disabled
                }
                
            }catch(error) {
                console.log('[survey][debug] error:: ', error);
            }

            // setTimeout(() => {
            //     dispatch(chatInit());
            //     // reload page on succsful survey submission
            //     window.location.reload(false);
            // }, 3000);
            dispatch(setToken(''));
            console.log('res: ', res.data);
        }catch(error) {
            console.log('error: ', error);
            // window.location.reload(false);
        }
    };

    return (
        <div style={{ height: '100%', position: 'relative' ,overflowY: 'scroll' }}>

        <Form onFinish={onFinish}>
            <div style={{
                padding: '10px 15px',
                fontSize: '14px'
            }}>
                Help us improve your chat experience by taking a brief survey.
                {questions.map((question, index) => {
                    if(question.type === 'rating')
                        return (
                            <div className="survey-box" key={index}>
                                <div>{question.question}</div>
                                <Form.Item name={`rating-${index}`}>
                                    <Rate />
                                </Form.Item>
                            </div>
                        );
                    if(question.type === 'comment') 
                        return (
                            <div key={index} style={{ marginTop: 10 }}>
                                <div>Additional Comments</div>
                                <Form.Item name={`comment-${index}`}>
                                    <TextArea  maxLength='2000' rows={3} />
                                </Form.Item>
                            </div>
                        );
                })}
            </div>
            <hr />
            <Form.Item>
                <Button 
                    style={{float: 'right', marginRight: '15px', color: '#fff'}} 
                    className="primary-color"
                    htmlType="submit"
                >
                    Send
                </Button>
            </Form.Item>
        </Form>
        </div>
    );
}

export default Survey;